import { getFromStorage } from '../components/utils';
import { URL_SERVICIOS } from './UrlWebServis';
import { getToken, getID } from './Usuario';

export function PostData(type, userData){    
    const url_api = URL_SERVICIOS;
    const usuario = getFromStorage("contarsEmpresa");
    const token = usuario.token;
    const id = usuario.id_usuario;
    // Si no existe, campus será 0
    const campus = usuario && usuario.id_empresa ? usuario.id_empresa : 0;

    return new Promise((resolve, reject) => {
        fetch(url_api+type+'/'+id+'/'+token+'/'+campus,{
            method: 'POST',
            body: JSON.stringify(userData)
        })
        .then((response) => response.json())
        .then((responseJson) => {
            resolve(responseJson);
        })
        .catch((error) => {
            console.log("Error " + error);
           userData.error_login =  true;
           reject(error);
           
        })
    })    
}